import { useEffect, useState } from 'react';

import { Translation } from '../../../domain/translation/Translation';
import { useUpdateTranslation } from '../../../hooks/backoffice/translations/useUpdateTranslation';
import InputText from '../../../react-components/InputText';

interface TranslationEditableFieldProps {
  translation: Translation;
  onEditTranslation: () => void;
}

export const TranslationEditableField = ({ translation, onEditTranslation }: TranslationEditableFieldProps) => {
  const { run: updateTranslation, success: updateSuccess, isLoading } = useUpdateTranslation();
  const [newValue, setNewValue] = useState<string>(translation.value);

  useEffect(() => {
    if (updateSuccess) {
      onEditTranslation();
    }
  }, [updateSuccess, onEditTranslation]);

  return (
    <div style={{ position: `relative` }}>
      <InputText
        fullWidth
        fieldValue={newValue}
        disabled={isLoading}
        inputContainerStyles={{ background: isLoading ? `#eee` : `transparent` }}
        onChange={(value) => setNewValue(value)}
        onBlur={() => {
          newValue !== translation.value &&
            updateTranslation({
              language: translation.language.value,
              key: translation.key,
              value: newValue,
              domain: translation.domain,
            });
        }}
        multiline={true}
        rowsMin={1}
        disableEnter
      />
    </div>
  );
};
